import { makeStyles, mergeClasses } from "@fluentui/react-components";
import type { AppPreviewGalleryState } from "./AppPreviewGallery.types";
import { customTokens } from "@1js/acui-theme";

const useAppPreviewGalleryRootStyles = makeStyles({
  base: {
    backgroundColor: customTokens.colorNeutralBackground1,
  },
  stack: {
    width: "444px",
  },
});

const useSizeStyles = makeStyles({
  // preview gallery can't be small
  medium: {
    height: "32px",
  },
  large: {
    height: "62px",
  },
});

const useAppPreviewGalleryHiddenFlyoutAnchorStyles = makeStyles({
  base: {
    visibility: "hidden",
    position: "absolute",
  },
});

const useAppPreviewGalleryActionFlyoutAnchorStyles = makeStyles({
  base: {
    position: "relative",
    display: "flex !important",
  },
});

/**
 * Container wraps around the Button Display and the Flyout Anchor components.
 * These styles are placing the components in a flex box
 */
const useAppPreviewGalleryContainerStyles = makeStyles({
  base: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    height: "inherit",
  },
});

export const useAppPreviewGalleryStyles: (
  state: AppPreviewGalleryState
) => AppPreviewGalleryState = (state) => {
  const rootStyles = useAppPreviewGalleryRootStyles();
  const sizeStyles = useSizeStyles();
  const hiddenFlyoutAnchorStyles =
    useAppPreviewGalleryHiddenFlyoutAnchorStyles();
  const actionFlyoutAnchorStyles =
    useAppPreviewGalleryActionFlyoutAnchorStyles();
  const containerStyles = useAppPreviewGalleryContainerStyles();

  state.root.className = mergeClasses(
    rootStyles.base,
    state.stack && rootStyles.stack,
    state.size === "large" ? sizeStyles.large : sizeStyles.medium,
    state.root.className
  );

  state.hiddenFlyoutAnchor.className = mergeClasses(
    hiddenFlyoutAnchorStyles.base,
    state.hiddenFlyoutAnchor.className
  );

  state.actionFlyoutAnchor.className = mergeClasses(
    actionFlyoutAnchorStyles.base,
    state.actionFlyoutAnchor.className
  );

  state.container.className = mergeClasses(
    containerStyles.base,
    state.container.className
  );

  return state;
};
